// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96f4f9ec","389":"9944c666","453":"3a66a830","455":"ce9d7873","857":"980ce4e2","977":"32e7bb79"}[chunkId] + ".chunk.js";
};